import React from 'react';
import { Briefcase, Mail, Linkedin, Twitter, Calendar, MapPin, Award, Layers, Users } from 'lucide-react';
export const Portfolio = () => {
  return <div className="w-full bg-white min-h-screen" data-id="element-4165">
      {/* Hero Section */}
      <section className="pt-20 pb-16 border-b border-gray-200" data-id="element-4166">
        <div className="container mx-auto px-4" data-id="element-4167">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-4168">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-4169">
              <div className="w-64 h-64 border-2 border-gray-300 rounded-full overflow-hidden" data-id="element-4170">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sGA11gNJc7vxEwMehjwPFv/dreyyyy.jpg" alt="Andrew Igbineweka" className="w-full h-full object-cover grayscale" loading="eager" width="256" height="256" data-id="element-4171" />
              </div>
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-4172">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-4173">
                Andrew Igbineweka
              </h1>
              <h2 className="text-2xl text-gray-600 mb-6" data-id="element-4174">
                Human Capital Development Professional
              </h2>
              <p className="text-gray-600 mb-6 max-w-2xl" data-id="element-4175">
                Passionate about connecting people to networks, ideas, and
                opportunities. Experienced in community building, strategic
                partnerships, and talent development.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-4176">
                <a href="mailto:andrew@example.com" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4177">
                  <Mail size={16} className="text-gray-600" data-id="element-4178" />
                  <span data-id="element-4179">Contact</span>
                </a>
                <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4180">
                  <Linkedin size={16} className="text-gray-600" data-id="element-4181" />
                  <span data-id="element-4182">LinkedIn</span>
                </a>
                <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4183">
                  <Twitter size={16} className="text-gray-600" data-id="element-4184" />
                  <span data-id="element-4185">Twitter</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-4186">
        <div className="container mx-auto px-4" data-id="element-4187">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4188">
            About Me
          </h2>
          <div className="flex flex-col md:flex-row gap-12" data-id="element-4189">
            <div className="w-full md:w-2/3" data-id="element-4190">
              <p className="text-gray-600 mb-6" data-id="element-4191">
                I am a Human Capital Development Professional with expertise in
                community building, strategic partnerships, and talent
                development. My work focuses on connecting young professionals
                to networks, ideas, and opportunities worldwide.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-4192">
                As the founder of The Networking Salon, I've built communities
                across multiple cities, creating platforms for meaningful
                connections and professional growth.
              </p>
              <p className="text-gray-600" data-id="element-4193">
                My approach combines strategic thinking with human-centered
                design, creating systems and experiences that help individuals
                and organizations thrive in today's rapidly evolving landscape.
              </p>
            </div>
            <div className="w-full md:w-1/3" data-id="element-4194">
              <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4195">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4196">
                  Details
                </h3>
                <ul className="space-y-4" data-id="element-4197">
                  <li className="flex items-center gap-3" data-id="element-4198">
                    <Calendar size={20} className="text-gray-500" data-id="element-4199" />
                    <div data-id="element-4200">
                      <p className="text-sm text-gray-500" data-id="element-4201">Experience</p>
                      <p className="text-gray-700" data-id="element-4202">7+ Years</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4203">
                    <MapPin size={20} className="text-gray-500" data-id="element-4204" />
                    <div data-id="element-4205">
                      <p className="text-sm text-gray-500" data-id="element-4206">Location</p>
                      <p className="text-gray-700" data-id="element-4207">Nigeria</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4208">
                    <Award size={20} className="text-gray-500" data-id="element-4209" />
                    <div data-id="element-4210">
                      <p className="text-sm text-gray-500" data-id="element-4211">Education</p>
                      <p className="text-gray-700" data-id="element-4212">
                        MBA, University of Nigeria
                      </p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4213">
                    <Layers size={20} className="text-gray-500" data-id="element-4214" />
                    <div data-id="element-4215">
                      <p className="text-sm text-gray-500" data-id="element-4216">Focus Areas</p>
                      <p className="text-gray-700" data-id="element-4217">
                        Community Building, Strategic Partnerships, Talent
                        Development
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Tools Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4218">
        <div className="container mx-auto px-4" data-id="element-4219">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4220">
            Tools & Skills
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4221">
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4222">
              <div className="flex items-center gap-3 mb-4" data-id="element-4223">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4224">
                  <div size={20} className="text-gray-600" data-id="element-4225" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4226">
                  Strategic Planning
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4227">
                <li className="flex items-center gap-2" data-id="element-4228">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4229"></div>
                  <span className="text-gray-600" data-id="element-4230">Stakeholder Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4231">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4232"></div>
                  <span className="text-gray-600" data-id="element-4233">SWOT Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4234">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4235"></div>
                  <span className="text-gray-600" data-id="element-4236">Project Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4237">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4238"></div>
                  <span className="text-gray-600" data-id="element-4239">Risk Assessment</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4240">
              <div className="flex items-center gap-3 mb-4" data-id="element-4241">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4242">
                  <Users size={20} className="text-gray-600" data-id="element-4243" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4244">
                  Community Building
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4245">
                <li className="flex items-center gap-2" data-id="element-4246">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4247"></div>
                  <span className="text-gray-600" data-id="element-4248">Event Planning</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4249">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4250"></div>
                  <span className="text-gray-600" data-id="element-4251">Member Engagement</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4252">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4253"></div>
                  <span className="text-gray-600" data-id="element-4254">Content Creation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4255">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4256"></div>
                  <span className="text-gray-600" data-id="element-4257">Relationship Management</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4258">
              <div className="flex items-center gap-3 mb-4" data-id="element-4259">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4260">
                  <Briefcase size={20} className="text-gray-600" data-id="element-4261" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4262">
                  Business Development
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4263">
                <li className="flex items-center gap-2" data-id="element-4264">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4265"></div>
                  <span className="text-gray-600" data-id="element-4266">Partnership Building</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4267">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4268"></div>
                  <span className="text-gray-600" data-id="element-4269">Negotiation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4270">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4271"></div>
                  <span className="text-gray-600" data-id="element-4272">
                    Client Relationship Management
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4273">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4274"></div>
                  <span className="text-gray-600" data-id="element-4275">Revenue Strategy</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4276">
              <div className="flex items-center gap-3 mb-4" data-id="element-4277">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4278">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4279"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4280">
                  Digital Tools
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4281">
                <li className="flex items-center gap-2" data-id="element-4282">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4283"></div>
                  <span className="text-gray-600" data-id="element-4284">Microsoft Office Suite</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4285">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4286"></div>
                  <span className="text-gray-600" data-id="element-4287">Google Workspace</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4288">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4289"></div>
                  <span className="text-gray-600" data-id="element-4290">Canva</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4291">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4292"></div>
                  <span className="text-gray-600" data-id="element-4293">CRM Systems</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4294">
              <div className="flex items-center gap-3 mb-4" data-id="element-4295">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4296">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4297"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4298">
                  Communication
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4299">
                <li className="flex items-center gap-2" data-id="element-4300">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4301"></div>
                  <span className="text-gray-600" data-id="element-4302">Public Speaking</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4303">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4304"></div>
                  <span className="text-gray-600" data-id="element-4305">Content Writing</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4306">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4307"></div>
                  <span className="text-gray-600" data-id="element-4308">Presentation Design</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4309">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4310"></div>
                  <span className="text-gray-600" data-id="element-4311">Storytelling</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4312">
              <div className="flex items-center gap-3 mb-4" data-id="element-4313">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4314">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4315"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4316">Leadership</h3>
              </div>
              <ul className="space-y-2" data-id="element-4317">
                <li className="flex items-center gap-2" data-id="element-4318">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4319"></div>
                  <span className="text-gray-600" data-id="element-4320">Team Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4321">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4322"></div>
                  <span className="text-gray-600" data-id="element-4323">Mentoring</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4324">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4325"></div>
                  <span className="text-gray-600" data-id="element-4326">Conflict Resolution</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4327">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4328"></div>
                  <span className="text-gray-600" data-id="element-4329">Decision Making</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Experience Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-4330">
        <div className="container mx-auto px-4" data-id="element-4331">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4332">
            Professional Experience
          </h2>
          <div className="space-y-8" data-id="element-4333">
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4334">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4335">
                <div data-id="element-4336">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4337">
                    Founder & CEO
                  </h3>
                  <p className="text-gray-600" data-id="element-4338">The Networking Salon</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4339">2018 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4340">
                <li data-id="element-4341">
                  Founded and scaled a global community initiative connecting
                  young professionals across 25+ cities worldwide
                </li>
                <li data-id="element-4342">
                  Developed strategic partnerships with organizations to create
                  opportunities for community members
                </li>
                <li data-id="element-4343">
                  Designed and implemented community-building frameworks and
                  engagement strategies
                </li>
                <li data-id="element-4344">
                  Led a team of city leads and volunteers to execute the vision
                  in multiple locations
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4345">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4346">
                <div data-id="element-4347">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4348">
                    Human Capital Development Consultant
                  </h3>
                  <p className="text-gray-600" data-id="element-4349">Various Organizations</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4350">2016 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4351">
                <li data-id="element-4352">
                  Provided strategic guidance on talent development and
                  organizational culture
                </li>
                <li data-id="element-4353">
                  Designed and facilitated leadership development programs and
                  workshops
                </li>
                <li data-id="element-4354">
                  Implemented community-building strategies for corporate
                  clients
                </li>
                <li data-id="element-4355">Advised on employee engagement and retention strategies</li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4356">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4357">
                <div data-id="element-4358">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4359">
                    Community Manager
                  </h3>
                  <p className="text-gray-600" data-id="element-4360">Tech Innovation Hub</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4361">2015 - 2018</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4362">
                <li data-id="element-4363">
                  Managed a community of tech entrepreneurs and innovators
                </li>
                <li data-id="element-4364">
                  Organized networking events, workshops, and skill-building
                  programs
                </li>
                <li data-id="element-4365">
                  Facilitated connections between community members and
                  potential investors/partners
                </li>
                <li data-id="element-4366">
                  Created content and communications strategies for community
                  engagement
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Brands Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4367">
        <div className="container mx-auto px-4" data-id="element-4368">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4369">
            Brands I've Worked With
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-4370">
            {/* Brand logos would go here - using placeholders for wireframe */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => <div key={item} className="flex items-center justify-center p-4 border border-gray-300 rounded-lg h-24" data-id="element-4371">
                <div className="w-16 h-8 bg-gray-300 rounded-md" data-id="element-4372"></div>
              </div>)}
          </div>
          <p className="text-center text-gray-500 mt-8" data-id="element-4373">
            Note: These are placeholder blocks for brand logos you've worked
            with. You'll need to add actual logos of brands from your
            experience.
          </p>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16" data-id="element-4374">
        <div className="container mx-auto px-4" data-id="element-4375">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4376">
            Get In Touch
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-4377">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4378">
              <a href="mailto:andrew@example.com" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4379">
                <Mail size={32} className="text-gray-600 mb-3" data-id="element-4380" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4381">Email</h3>
                <p className="text-gray-600 text-center" data-id="element-4382">andrew@example.com</p>
              </a>
              <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4383">
                <Linkedin size={32} className="text-gray-600 mb-3" data-id="element-4384" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4385">
                  LinkedIn
                </h3>
                <p className="text-gray-600 text-center" data-id="element-4386">andrewigbineweka</p>
              </a>
              <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4387">
                <Twitter size={32} className="text-gray-600 mb-3" data-id="element-4388" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4389">
                  Twitter
                </h3>
                <p className="text-gray-600 text-center" data-id="element-4390">@andrewigbineweka</p>
              </a>
            </div>
            <div className="text-center" data-id="element-4391">
              <p className="text-gray-600 mb-6" data-id="element-4392">
                Interested in working together? I'm always open to discussing
                new projects, opportunities and partnerships.
              </p>
              <a href="mailto:andrew@example.com" className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md hover:bg-gray-800 hover:text-white transition-colors" data-id="element-4393">
                <Mail size={18} data-id="element-4394" />
                <span className="font-bold" data-id="element-4395">Send Me a Message</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 border-t border-gray-200 bg-gray-50" data-id="element-4396">
        <div className="container mx-auto px-4 text-center" data-id="element-4397">
          <p className="text-gray-600" data-id="element-4398">
            &copy; {new Date().getFullYear()} Andrew Igbineweka. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
};